module.exports = {"title":{"en":"Page not found","de":"Seite nicht gefunden"},"alertText":{"en":"This page was either removed, or did never exists on this website.","de":"Diese Seite wurde entweder entfernt oder war auf dieser Website nie vorhanden."}}


//////////////////
// WEBPACK FOOTER
// ./src/localization/localization-notFound.json
// module id = 107
// module chunks = 0